var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{class:[_vm.btnInverted ? _vm.btnThemeInverted : _vm.btnTheme ],on:{"click":_vm.linkAction}},[_vm._v("\n    "+_vm._s(_vm.btnName)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }